import { render } from "./BoardingPlaceDeleteModal.vue?vue&type=template&id=b1977d88"
import script from "./BoardingPlaceDeleteModal.vue?vue&type=script&lang=js"
export * from "./BoardingPlaceDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__